import React from 'react';
import {Paper, Typography} from "@mui/material";

import ProcurementContainer from '../../procurement/containers/ProcurementContainer';
import ItemsLocationList from '../lists/itemsLocationList';


const ItemsLocationPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        Item Stock in Locations
      </Typography>
      {/* <Paper sx={{my: 5}}>
        <CreateItemsLocationComponent/>
      </Paper> */}
      <Paper sx={{my: 5}}>
        <ItemsLocationList/>
      </Paper>
    </ProcurementContainer>

  )
}

export default ItemsLocationPage